
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';

export default function Home() {
  const features = [
    {
      icon: 'ri-price-tag-3-line',
      title: 'Best Prices',
      description: 'Competitive rates on all sanitary and hardware products'
    },
    {
      icon: 'ri-medal-line',
      title: 'High Quality',
      description: 'Premium quality products from trusted brands'
    },
    {
      icon: 'ri-store-2-line',
      title: 'Wide Range',
      description: 'Complete selection of bathroom, kitchen & hardware items'
    },
    {
      icon: 'ri-truck-line',
      title: 'Fast Service',
      description: 'Quick delivery and professional customer support'
    }
  ];

  const featuredProducts = [
    {
      name: 'Premium Bathroom Taps',
      category: 'Bathroom Sanitary',
      image: 'https://public.readdy.ai/ai/img_res/092ead9b65d4a9a5f2c339c9bb6a0499.jpg'
    },
    {
      name: 'Kitchen Sink Stainless Steel',
      category: 'Kitchen Items',
      image: 'https://readdy.ai/api/search-image?query=stainless%20steel%20kitchen%20sink%20with%20modern%20design%20on%20white%20background%2C%20professional%20product%20photography%2C%20high%20quality%20kitchen%20fixture%2C%20clean%20minimalist%20style%2C%20studio%20lighting&width=400&height=400&seq=sink1&orientation=squarish'
    },
    {
      name: 'Shower Cabin Set',
      category: 'Bathroom Sanitary',
      image: 'https://readdy.ai/api/search-image?query=modern%20glass%20shower%20cabin%20enclosure%20with%20chrome%20fixtures%20on%20white%20background%2C%20professional%20product%20photography%2C%20high%20quality%20bathroom%20fixture%2C%20minimalist%20design%2C%20studio%20lighting&width=400&height=400&seq=shower1&orientation=squarish'
    },
    {
      name: 'UPVC Pipes & Fittings',
      category: 'Pipes and Fittings',
      image: 'https://readdy.ai/api/search-image?query=white%20UPVC%20pipes%20and%20fittings%20arranged%20neatly%20on%20clean%20background%2C%20professional%20product%20photography%2C%20plumbing%20supplies%2C%20high%20quality%20materials%2C%20studio%20lighting&width=400&height=400&seq=pipe1&orientation=squarish'
    }
  ];

  const testimonials = [
    {
      name: 'Ahmed Hassan',
      location: 'Bahria Town, Islamabad',
      rating: 5,
      text: 'Excellent quality products and very reasonable prices. I renovated my entire bathroom from Malik Brothers. The staff is very cooperative and knowledgeable. Highly recommended!',
      image: 'https://readdy.ai/api/search-image?query=professional%20Pakistani%20businessman%20portrait%2C%20confident%20smile%2C%20modern%20office%20background%2C%20business%20attire%2C%20professional%20headshot%20photography&width=100&height=100&seq=client1&orientation=squarish'
    },
    {
      name: 'Fatima Khan',
      location: 'DHA Phase 2, Islamabad',
      rating: 5,
      text: 'Best sanitary shop in Rawalpindi! I bought kitchen sink and bathroom fittings for my new house. Quality is outstanding and prices are very competitive. Very satisfied with their service.',
      image: 'https://readdy.ai/api/search-image?query=professional%20Pakistani%20businesswoman%20portrait%2C%20friendly%20smile%2C%20modern%20office%20background%2C%20professional%20attire%2C%20headshot%20photography&width=100&height=100&seq=client2&orientation=squarish'
    },
    {
      name: 'Muhammad Bilal',
      location: 'Bahria Town Phase 7, Rawalpindi',
      rating: 5,
      text: 'I am a contractor and always buy from Malik Brothers for my projects. They have everything in stock and give good wholesale rates. Very trustworthy and reliable business.',
      image: 'https://readdy.ai/api/search-image?query=professional%20Pakistani%20contractor%20portrait%2C%20confident%20expression%2C%20construction%20site%20background%2C%20safety%20vest%2C%20professional%20photography&width=100&height=100&seq=client3&orientation=squarish'
    },
    {
      name: 'Sana Malik',
      location: 'G-13, Islamabad',
      rating: 5,
      text: 'Very good experience! Staff helped me choose the right products for my bathroom renovation. Quality is excellent and installation guidance was very helpful. Will definitely come back.',
      image: 'https://readdy.ai/api/search-image?query=professional%20Pakistani%20woman%20portrait%2C%20warm%20smile%2C%20modern%20interior%20background%2C%20casual%20professional%20attire%2C%20headshot%20photography&width=100&height=100&seq=client4&orientation=squarish'
    },
    {
      name: 'Imran Ali',
      location: 'Bahria Enclave, Islamabad',
      rating: 5,
      text: 'Malik Brothers is my go-to place for all plumbing and sanitary needs. Wide variety of products, genuine quality, and fair prices. The owner is very honest and helpful.',
      image: 'https://readdy.ai/api/search-image?query=professional%20Pakistani%20businessman%20portrait%2C%20friendly%20smile%2C%20office%20background%2C%20business%20casual%20attire%2C%20professional%20headshot&width=100&height=100&seq=client5&orientation=squarish'
    },
    {
      name: 'Ayesha Tariq',
      location: 'PWD, Islamabad',
      rating: 5,
      text: 'Bought complete bathroom and kitchen fittings from here. Everything is of premium quality and prices are much better than other shops. Highly recommend Malik Brothers!',
      image: 'https://readdy.ai/api/search-image?query=professional%20Pakistani%20woman%20portrait%2C%20confident%20smile%2C%20modern%20background%2C%20professional%20attire%2C%20headshot%20photography&width=100&height=100&seq=client6&orientation=squarish'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <WhatsAppButton />

      {/* Hero Section */}
      <section 
        className="relative h-screen flex items-center justify-center bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(234, 88, 12, 0.85), rgba(249, 115, 22, 0.75)), url('https://readdy.ai/api/search-image?query=modern%20professional%20sanitary%20showroom%20interior%20with%20elegant%20bathroom%20fixtures%2C%20chrome%20taps%20and%20fittings%20displayed%20beautifully%2C%20clean%20white%20tiles%2C%20bright%20lighting%2C%20spacious%20layout%2C%20professional%20retail%20environment%2C%20high%20quality%20sanitary%20ware%20store&width=1920&height=1080&seq=hero1&orientation=landscape')`
        }}
      >
        <div className="container mx-auto px-4 text-center text-white">
          <h1 className="text-5xl md:text-7xl font-bold mb-6" style={{ fontFamily: '"Pacifico", serif' }}>Malik Brothers</h1>
          <p className="text-2xl md:text-3xl mb-8 font-light">The Name of Quality & Trust</p>
          <p className="text-lg md:text-xl mb-10 max-w-2xl mx-auto">Your trusted partner for premium sanitary ware, kitchen fixtures, pipes, and hardware tools in Rawalpindi</p>
          <div className="flex flex-wrap gap-4 justify-center">
            <Link 
              to="/products" 
              className="bg-orange-600 hover:bg-orange-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all whitespace-nowrap cursor-pointer"
            >
              View Products
            </Link>
            <Link 
              to="/contact" 
              className="bg-white hover:bg-gray-100 text-orange-600 px-8 py-4 rounded-lg text-lg font-semibold transition-all whitespace-nowrap cursor-pointer"
            >
              Contact Now
            </Link>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold text-center mb-16 text-gray-800">Why Choose Malik Brothers</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {features.map((feature, index) => (
              <div key={index} className="bg-white p-8 rounded-xl shadow-md hover:shadow-xl transition-all text-center">
                <div className="w-16 h-16 flex items-center justify-center bg-orange-100 rounded-full mx-auto mb-6">
                  <i className={`${feature.icon} text-3xl text-orange-600`}></i>
                </div>
                <h3 className="text-xl font-bold mb-3 text-gray-800">{feature.title}</h3>
                <p className="text-gray-600">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Featured Products Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold text-center mb-4 text-gray-800">Featured Products</h2>
          <p className="text-center text-gray-600 mb-16 text-lg">Explore our premium selection of sanitary and hardware products</p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {featuredProducts.map((product, index) => (
              <div key={index} className="bg-white rounded-xl shadow-md hover:shadow-xl transition-all overflow-hidden group cursor-pointer" data-product-shop>
                <div className="overflow-hidden">
                  <img 
                    src={product.image} 
                    alt={product.name}
                    className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-300"
                  />
                </div>
                <div className="p-6">
                  <p className="text-sm text-orange-600 font-semibold mb-2">{product.category}</p>
                  <h3 className="text-lg font-bold mb-4 text-gray-800">{product.name}</h3>
                  <a 
                    href="https://wa.me/923135224547" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="block w-full bg-orange-600 hover:bg-orange-700 text-white text-center py-3 rounded-lg font-semibold transition-all whitespace-nowrap cursor-pointer"
                  >
                    Call for Price
                  </a>
                </div>
              </div>
            ))}
          </div>
          <div className="text-center mt-12">
            <Link 
              to="/products" 
              className="inline-block bg-orange-600 hover:bg-orange-700 text-white px-10 py-4 rounded-lg text-lg font-semibold transition-all whitespace-nowrap cursor-pointer"
            >
              View All Products
            </Link>
          </div>
        </div>
      </section>

      {/* Customer Reviews Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold text-center mb-4 text-gray-800">What Our Customers Say</h2>
          <p className="text-center text-gray-600 mb-16 text-lg">Trusted by customers across Islamabad and Rawalpindi</p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="bg-white p-8 rounded-xl shadow-md hover:shadow-xl transition-all">
                <div className="flex items-center gap-4 mb-6">
                  <img 
                    src={testimonial.image} 
                    alt={testimonial.name}
                    className="w-16 h-16 rounded-full object-cover"
                  />
                  <div>
                    <h4 className="font-bold text-gray-800">{testimonial.name}</h4>
                    <p className="text-sm text-gray-500">{testimonial.location}</p>
                  </div>
                </div>
                <div className="flex gap-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-orange-500 text-lg"></i>
                  ))}
                </div>
                <p className="text-gray-600 leading-relaxed">{testimonial.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold text-center mb-16 text-gray-800">Our Services</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            <div className="bg-white p-8 rounded-xl shadow-md hover:shadow-xl transition-all text-center border-2 border-gray-100">
              <div className="w-16 h-16 flex items-center justify-center bg-orange-100 rounded-full mx-auto mb-6">
                <i className="ri-shopping-cart-line text-3xl text-orange-600"></i>
              </div>
              <h3 className="text-xl font-bold mb-3 text-gray-800">Retail Service</h3>
              <p className="text-gray-600">Quality products for individual customers at competitive prices</p>
            </div>
            <div className="bg-white p-8 rounded-xl shadow-md hover:shadow-xl transition-all text-center border-2 border-gray-100">
              <div className="w-16 h-16 flex items-center justify-center bg-orange-100 rounded-full mx-auto mb-6">
                <i className="ri-store-3-line text-3xl text-orange-600"></i>
              </div>
              <h3 className="text-xl font-bold mb-3 text-gray-800">Wholesale Service</h3>
              <p className="text-gray-600">Bulk orders for contractors and businesses with special rates</p>
            </div>
            <div className="bg-white p-8 rounded-xl shadow-md hover:shadow-xl transition-all text-center border-2 border-gray-100">
              <div className="w-16 h-16 flex items-center justify-center bg-orange-100 rounded-full mx-auto mb-6">
                <i className="ri-customer-service-2-line text-3xl text-orange-600"></i>
              </div>
              <h3 className="text-xl font-bold mb-3 text-gray-800">Expert Guidance</h3>
              <p className="text-gray-600">Professional consultation for product selection and installation</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-orange-600 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold mb-6">Ready to Get Started?</h2>
          <p className="text-xl mb-10 max-w-2xl mx-auto">Visit our store or contact us today for the best deals on sanitary and hardware products</p>
          <div className="flex flex-wrap gap-4 justify-center">
            <Link 
              to="/contact" 
              className="bg-white hover:bg-gray-100 text-orange-600 px-10 py-4 rounded-lg text-lg font-semibold transition-all whitespace-nowrap cursor-pointer"
            >
              Contact Us
            </Link>
            <a 
              href="https://wa.me/923135224547" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-green-500 hover:bg-green-600 text-white px-10 py-4 rounded-lg text-lg font-semibold transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
            >
              <i className="ri-whatsapp-line text-2xl"></i>
              WhatsApp Now
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
